import { TriangleAlert } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { useFeatureFlags } from '@/hooks/use-feature-flags';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { ExternalLinkButton } from '@/components/external-link-button';

export function CustomPaymentLinkModal() {
  const { LL } = useI18nContext();
  const featureFlags = useFeatureFlags();

  const customPaymentLink = featureFlags.data?.customPaymentLink?.trim();

  const shouldShow =
    customPaymentLink != null &&
    customPaymentLink !== '' &&
    !featureFlags.isLoading;

  if (!shouldShow) {
    return null;
  }

  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mb-2 flex justify-center">
            <span className="rounded-full bg-yellow-100 p-3 text-yellow-700">
              <TriangleAlert className="size-6" />
            </span>
          </div>
          <AlertDialogTitle className="text-center text-xl">
            {LL.billingLockModal.title()}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {LL.billingLockModal.description()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <ExternalLinkButton className="w-full" href={customPaymentLink}>
            {LL.billingLockModal.activateSubscriptionButton()}
          </ExternalLinkButton>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
